// extracted by mini-css-extract-plugin
export default {"root":"SearchMapClustered_root__xFOMf","mapContainer":"SearchMapClustered_mapContainer__zpdUl"};